export const genders = [
  'Male',
  'Female',
];
